import React from 'react';
import Datetime from 'react-datetime';
import map from 'lodash/map';
import {
    Button,
    Col,
    ControlLabel,
    Form,
    FormGroup,
    FormControl,
    Panel,
    Row,
} from 'react-bootstrap';
import { ABNORMALITIES, ABNORMALITY_STATUSES, EXCLUDE_PSS_SS_OPTION, I18N } from '../../../constants';
import { searchFormHasValues } from '../../../shared/utils/search';

export default class TodoSearch extends React.PureComponent {
    render() {
        const {
            search,
            isFetching,
            handleChange,
            handleDateChange,
            handleSubmit,
            handleReset,
        } = this.props;

        return (
            <Panel collapsible defaultExpanded={searchFormHasValues(search)} header={'Search'}>
                <Form horizontal onSubmit={handleSubmit}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="tlmsUpdate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    TLMS update
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="tlmsUpdate"
                                        value={search.tlmsUpdate}
                                        placeholder="..."
                                        onChange={handleChange}
                                    >
                                        <option value="">...</option>
                                        <option value="VALIDATE">
                                            {I18N.TLMS_UPDATE.VALIDATE}
                                        </option>
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="abnormalityName">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Abn. name
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="abnormalityName"
                                        value={search.abnormalityName}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="abnormalityDate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Abn. date
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        name="abnormalityDate"
                                        value={search.abnormalityDate}
                                        onChange={handleDateChange('abnormalityDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        inputProps={{
                                            maxLength: 255,
                                            placeholder: '...',
                                        }}
                                        closeOnSelect
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="abnormalityType">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Abn. type
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="abnormalityType"
                                        value={search.abnormalityType}
                                        onChange={handleChange}
                                    >
                                        <option value="">...</option>
                                        {map(ABNORMALITIES, a => (
                                            <option key={a} value={a}>
                                                {I18N.ABNORMALITIES[a]}
                                            </option>
                                        ))}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="routeCode">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Route code
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="routeCode"
                                        value={search.routeCode}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="runDate">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Run date
                                </Col>
                                <Col sm={6}>
                                    <Datetime
                                        name="runDate"
                                        value={search.runDate}
                                        onChange={handleDateChange('runDate')}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat={false}
                                        className="date-input"
                                        inputProps={{
                                            maxLength: 255,
                                            placeholder: '...',
                                        }}
                                        closeOnSelect
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="destination">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Destination
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="destination"
                                        value={search.destination}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="location">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Location
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="location"
                                        value={search.location}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="assigneeGroup">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Assignee group
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="assigneeGroup"
                                        value={search.assigneeGroup}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={3} className="no-gutter">
                            <FormGroup controlId="assignee">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Assignee
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        type="text"
                                        maxLength="1000"
                                        name="assignee"
                                        value={search.assignee}
                                        placeholder="..."
                                        onChange={handleChange}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup controlId="abnormalityStatus">
                                <Col componentClass={ControlLabel} sm={5}>
                                    Status
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="abnormalityStatus"
                                        value={search.abnormalityStatus}
                                        onChange={handleChange}
                                    >
                                        <option value="">...</option>
                                        {map(ABNORMALITY_STATUSES, s => (
                                            <option key={s} value={s}>
                                                {I18N.ABNORMALITY_STATUS[s]}
                                            </option>
                                        ))}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                            {/* <FormGroup controlId="isExcludePartialAndShortShipment">
                            <Col
                                componentClass={ControlLabel}
                                sm={5}
                                title="isExcludePartialAndShortShipment"
                            >
                                Exclude Partial and Short shipment?
                            </Col>
                            <Col sm={6} style={{ marginTop: -7, marginBottom: 7 }}>
                                <Checkbox
                                    name="isExcludePartialAndShortShipment"
                                    checked={search.isExcludePartialAndShortShipment}
                                    onChange={handleCheckboxChange}
                                    inline
                                />
                            </Col>
                            </FormGroup> */}
                             <FormGroup controlId="excludePSSAndSS">
                                <Col
                                    componentClass={ControlLabel}
                                    sm={5}
                                >
                                    Exclude PSS and SS
                                </Col>
                                <Col sm={6}>
                                    <FormControl
                                        componentClass="select"
                                        name="excludePSSAndSS"
                                        value={search.excludePSSAndSS}
                                        onChange={handleChange}
                                    >    
                                        <option value="">...</option>
                                        {map(EXCLUDE_PSS_SS_OPTION, s => (
                                            <option key={s} value={s}>
                                                {I18N.EXCLUDE_PSS_SS[s]}
                                            </option>
                                        ))}
                                    </FormControl>
                                </Col>
                                </FormGroup>
                            <FormGroup>
                                <Col sm={3} smOffset={5}>
                                    <Button
                                        type="submit"
                                        style={{ width: '100%' }}
                                        bsStyle="primary"
                                        disabled={isFetching}
                                    >
                                        {isFetching ? '...' : 'Search'}
                                    </Button>
                                </Col>
                                <Col sm={3}>
                                    <Button
                                        type="reset"
                                        style={{ width: '100%' }}
                                        disabled={isFetching}
                                        onClick={handleReset}
                                    >
                                        Reset
                                    </Button>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </Panel>
        );
    }
}
